// Add [data-notab] to any html element you don't want to be tabbable
import Dom from '../utility/dom';

const Modal = {
    open: function(target){
        for (let element of Dom.focusable) {
            element.setAttribute('tabindex', '-1');
            if(!element.hasAttribute('data-notab') && (element.closest('.modal') == target || target.contains(element)) ){
                element.setAttribute('tabindex', '1');
            }
        }

        // Watch for video embeds not included in Dom.focusable. 
        // as well as splide slides that get tabindex set by splide 
        const slipperyEls = document.querySelectorAll('iframe, .splide__slide a');
        if(slipperyEls){
            slipperyEls.forEach(el => {
                // First check if it's already set at -1 tabindex, if so, leave alone.
                const tabIndex = el.getAttribute('tabindex');

                if(!tabIndex || tabIndex !== '-1'){
                    const src = el.getAttribute('src');
                    
                    if(((src && (src.includes('youtube') || src.includes('vimeo'))) || el.closest('.splide__slide'))
                    && (!el.closest('.modal') == target || !el.closest('.modal')) 
                    && !target.contains(el)){
                        el.classList.add('noTab');
                        el.setAttribute('tabindex', '-1');
                    }
                }
            });
        }
    },
    close: function(target){
        for (let element of Dom.focusable) {
            if(element.hasAttribute('data-notab') 
            || element.closest('.modal') == target 
            || target.contains(element)
            || element.closest('[aria-hidden="true"]')){
                element.setAttribute('tabindex', '-1');
            }
            else {
                element.setAttribute('tabindex', '1');
            }
        }

        // Watch for video embeds not included in Dom.focusable
        // or splide slide a elements.    
        const slipperyEls = document.querySelectorAll('iframe.noTab, .splide__slide a.noTab');
        if(slipperyEls){
            slipperyEls.forEach(el => {
                if(!el.closest('.modal') == target && !target.contains(el)){
                    el.classList.remove('noTab');
                    el.setAttribute('tabindex', '1');
                }
            });
        }
    },
    setToFocusable: function(target){
        for(let element of Dom.focusable){
            if(target.contains(element)){
                element.setAttribute('tabindex', '1');
            }
        }
    }
}


export default Modal;
